import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ConsolidatedForecastingRoutes } from '@futrli/predict-next/forecasting/dashboard/consolidated-routes';
import { ForecastingTabId } from '@futrli/predict-next/forecasting/dashboard/containers/forecasting-dashboard-container-new';
import { ROUTES } from '@futrli/shared-services';

import { ConsolidatedForecastContainer } from '../detail/containers/consolidated-forecast-container';

export const ConsolidatedForecastingContainer = () => (
  <Routes>
    <Route index element={<ConsolidatedForecastingRoutes />} />
    <Route path={`${ForecastingTabId.FORECASTS_LIST}/*`} element={<ConsolidatedForecastingRoutes />} />
    <Route path={`${ForecastingTabId.PERFORMANCE_COMPARISON}/*`} element={<ConsolidatedForecastingRoutes />} />
    <Route path={`${ROUTES.FORECAST_BY_ID}/*`} element={<ConsolidatedForecastContainer />} />
  </Routes>
);
